import React from 'react'
import { ThemedRender } from '../../__styling/themed-render'
import { StyledTimestamp } from './CardTimestamp.styled'
import {
    getTimeAgo,
    getTime,
    getDateTime,
    getFullDateTime,
} from '@news-mono/web-common'
import { Skeleton } from '../Skeleton/Skeleton'
import { useProduct } from '../../__product/useProduct'

export type TimestampStyle = 'full' | 'time-only' | 'relative'
export type TimestampType =
    | 'rounded-in-kicker'
    | 'full-at-bottom'
    | 'list-style'

export interface TimestampProps {
    loading?: boolean
    time?: string
    timestampStyle?: TimestampStyle
    className?: string
}

const renderTime = (props: TimestampProps) => {
    const { timestampStyle, className } = props
    const time = props.time ? props.time : ''
    const dateTime = getDateTime(time)
    const fullDateTime = getFullDateTime(time)

    return (
        <ThemedRender
            perthnow={() => (
                <StyledTimestamp className={className} dateTime={dateTime}>
                    {getTime(time)}
                </StyledTimestamp>
            )}
            thewest={() => (
                <StyledTimestamp className={className} dateTime={dateTime}>
                    {timestampStyle === 'full'
                        ? fullDateTime
                        : getTime(time, true)}
                </StyledTimestamp>
            )}
            sevennews={() => (
                <StyledTimestamp className={className} dateTime={dateTime}>
                    {timestampStyle === 'relative'
                        ? getTimeAgo(time)
                        : getTime(time, true, true)}
                </StyledTimestamp>
            )}
        />
    )
}

export const Timestamp: React.FC<TimestampProps> = (props) => {
    const { loading, time, className } = props
    const product = useProduct()

    return loading || !time ? (
        <StyledTimestamp className={className}>
            {product !== 'perthnow' ? <Skeleton /> : <time>&zwnj;</time>}
        </StyledTimestamp>
    ) : (
        renderTime(props)
    )
}
Timestamp.displayName = 'Card-Timestamp'
